import React, { useEffect, useRef, useState } from 'react';
import './RydeAssuredCard.css';
import {
  formatHighlight,
  isLeftScrollable,
  isRightScrollable
} from '../../utils/rydeUtils';
import { getAppEnv } from '../../../config/env';
import { Usp, UspInfo } from '../../pages/runtime-typechecker';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export type RydeAssuredItem = {
  rydeUspsCardInfo: UspInfo;
  uspsList: Usp[] | null;
};

type RydeAssuredCardProps = {
  benefits: RydeAssuredItem | null;
};

const getClassForMaxLayoutWidth = (): string => {
  return 'maxWidth1200';
};

const getClassForCardWidth = (totalNoOfCards: number): string => {
  if (totalNoOfCards === 2) {
    return 'width50percent';
  } else if (totalNoOfCards === 3) {
    return 'width3Cards';
  } else {
    return 'width300';
  }
};

const RydeAssuredCard = (props: RydeAssuredCardProps) => {
  const navRef = useRef<any>(null);
  const [leftScrollable, setLeftScrollable] = useState<boolean>(false);
  const [rightScrollable, setRightScrollable] = useState<boolean>(false);

  useEffect(() => {
    setLeftScrollable(isLeftScrollable(navRef));
    setRightScrollable(isRightScrollable(navRef));
  }, []);

  const scrollHorizontalLeft = () => {
    if (navRef?.current?.scrollLeft !== undefined) {
      const offsetWidth: number = navRef?.current?.offsetWidth || 0;
      navRef.current.scrollLeft -= offsetWidth - 30;
    }
    setLeftScrollable(isLeftScrollable(navRef));
    setRightScrollable(isRightScrollable(navRef));
  };

  const scrollHorizontalRight = () => {
    if (navRef?.current?.scrollLeft !== undefined) {
      const offsetWidth: number = navRef?.current?.offsetWidth || 0;
      navRef.current.scrollLeft += offsetWidth - 30;
    }
    setLeftScrollable(isLeftScrollable(navRef));
    setRightScrollable(isRightScrollable(navRef));
  };

  return (
    <div className="rapAssuredPartner">
      <div className="makeFlex spaceBetween appendBottom10">
        <div>
          <div className="makeFlex alignCenter">
            <img
              className="persuasionLogo appendLeft10"
              alt="ryde_logo"
              src={`${PUBLIC_URL}/static/public/${props?.benefits?.rydeUspsCardInfo?.logoUrl}`}
            />
            {props?.benefits?.rydeUspsCardInfo?.uspTitle && (
              <p className="latoBlack font22 appendLeft5 rydeTitle">
                {formatHighlight(
                  props?.benefits?.rydeUspsCardInfo?.uspTitle,
                  'latoBold'
                )}
              </p>
            )}
          </div>
          {props?.benefits?.rydeUspsCardInfo?.uspDescription && (
            <p className="font16 blackText appendLeft10 appendTop5">
              {formatHighlight(
                props?.benefits?.rydeUspsCardInfo?.uspDescription,
                'latoBold'
              )}
            </p>
          )}
        </div>
        {(leftScrollable || rightScrollable) && (
          <div className="hrtlScrollButton makeFlex spaceBetween hrtlCenter paddingLR12">
            <span onClick={() => scrollHorizontalLeft()}>
              <img
                className={`maxSize12 ${leftScrollable ? 'rotate180' : ''}`}
                src={
                  leftScrollable
                    ? `${PUBLIC_URL}/static/public/arrow_blue_go_right.png`
                    : `${PUBLIC_URL}/static/public/arrow_grey_go_left.png`
                }
                alt="left scroll"
              />
            </span>
            <span onClick={() => scrollHorizontalRight()}>
              <img
                className={`maxSize12 ${rightScrollable ? '' : 'rotate180'}`}
                src={
                  leftScrollable
                    ? `${PUBLIC_URL}/static/public/arrow_grey_go_left.png`
                    : `${PUBLIC_URL}/static/public/arrow_blue_go_right.png`
                }
                alt="right scroll"
              />
            </span>
          </div>
        )}
      </div>
      <div
        className={`makeFlex bodyNotOverflow mweb ${getClassForMaxLayoutWidth()}`}
        ref={navRef}
      >
        {props.benefits &&
          props.benefits.uspsList &&
          props?.benefits?.uspsList.map((value: Usp, idx) => (
            <div
              key={'tripBenefit__' + idx}
              className={`tripBenefitCard ${getClassForCardWidth(
                (props?.benefits?.uspsList &&
                  props?.benefits?.uspsList.length) ||
                  0
              )}`}
            >
              <span className="rydeUspLogo">
                <img
                  src={`${PUBLIC_URL}/static/public/${value.logoDTUrl}`}
                  alt={`amentites_${idx}`}
                  height={56}
                  width={56}
                />
              </span>
              <div
                className={`${
                  getClassForCardWidth(
                    (props?.benefits?.uspsList &&
                      props?.benefits?.uspsList.length) ||
                      0
                  ) === 'width50percent'
                    ? 'appendLeft20'
                    : ''
                } uspTextItem`}
              >
                <p className="latoBold font16 blackText appendBottom5">
                  {value.uspTitle}
                </p>
                <p className="lightGreyText">{value.uspDescription}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default RydeAssuredCard;
